export const ROUTE = {
  FieldSelection: '/field-selection-web',
  DataInbox: '/data-inbox',
  ModuleFederation: '/module-federation',
  FixitTool: '/fixit-tool',
  Dashboard: '/dashboard',
  Dmb: '/dmb',
  Connect: '/partners',
  Partners: '/partners',
  Reports: '/reports',
  SeasonReports: '/season-reports',
  CropPlanning: '/crop-planning',
  Programs: '/programs',
  DataHub: '/analytics',
  AskFieldView: '/ask-fieldview-web',
  Home: '/field-selection-web',
  Auth: '/auth',
  VariableRate: '/variable-rate',
  ScriptCreator: '/script-creator',
  Settings: '/settings',
  InSeason: '/in-season',
  OperationHub: '/operation-hub',
  Fuse: '/fuse',
};
